import { AnyAction, Reducer } from 'redux'

import { LastServiceResponse, SessionState, SessionTypes } from './types'

const INITIAL_STATE: SessionState = {
  sessionId: '',
  sessionCreateDate: undefined,
  utmSource: '',
  utmMedium: '',
  utmContent: '',
  utmCampaign: '',
  facebookId: '',
  gaClientId: '',
  gaClid: '',
  cpfSession: undefined,
  accessToken: undefined,
  userNameSession: undefined,
  campanha: '',
  sangueLaranja: false,
  lastServiceCode: undefined,
  lastServiceName: undefined,
}

type SessionHandler = (state: SessionState, payload: unknown) => SessionState

const sessionHandlers: Partial<Record<SessionTypes, SessionHandler>> = {
  [SessionTypes.SET_SESSION_ID]: (state, payload) => ({
    ...state,
    sessionId: payload as string,
    sessionCreateDate: new Date(),
  }),
  [SessionTypes.SET_SESSION_CREATE_DATE]: (state, payload) => ({
    ...state,
    sessionCreateDate: payload as Date,
  }),
  [SessionTypes.SET_UTM_SOURCE]: (state, payload) => ({ ...state, utmSource: payload as string }),
  [SessionTypes.SET_UTM_MEDIUM]: (state, payload) => ({ ...state, utmMedium: payload as string }),
  [SessionTypes.SET_UTM_CONTENT]: (state, payload) => ({ ...state, utmContent: payload as string }),
  [SessionTypes.SET_UTM_CAMPAIGN]: (state, payload) => ({
    ...state,
    utmCampaign: payload as string,
  }),
  [SessionTypes.SET_FACEBOOK_ID]: (state, payload) => ({ ...state, facebookId: payload as string }),
  [SessionTypes.SET_GA_CLIENT_ID]: (state, payload) => ({
    ...state,
    gaClientId: payload as string,
  }),
  [SessionTypes.SET_GA_CLID]: (state, payload) => ({ ...state, gaClid: payload as string }),
  [SessionTypes.SET_CPF_SESSION]: (state, payload) => ({ ...state, cpfSession: payload as string }),
  [SessionTypes.SET_ACCESS_TOKEN]: (state, payload) => ({
    ...state,
    accessToken: payload as string,
  }),
  [SessionTypes.SET_USER_NAME_SESSION]: (state, payload) => ({
    ...state,
    userNameSession: payload as string,
  }),
  [SessionTypes.SET_CAMPANHA]: (state, payload) => ({ ...state, campanha: payload as string }),
  [SessionTypes.SET_SANGUE_LARANJA]: (state, payload) => ({
    ...state,
    sangueLaranja: payload as boolean,
  }),
  [SessionTypes.SET_LAST_SERVICE_RESPONSE]: (state, payload) => {
    const { code, serviceName } = payload as LastServiceResponse
    return {
      ...state,
      lastServiceCode: code,
      lastServiceName: serviceName,
    }
  },
}

const reducer: Reducer<SessionState> = (state = INITIAL_STATE, action: AnyAction) => {
  const handler = sessionHandlers[action.type as SessionTypes]
  if (!handler) return state
  return handler(state, action.payload)
}

export default reducer
